import React from "react";
import {
  Grid,
  Card,
  CardMedia,
  CardContent,
  CardActions,
  Button,
  Typography,
  Box,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";

const ProductGrid = ({ products, IMAGE_BASE_URL, onAddToCart }) => {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));
  const placeholderImage = "https://via.placeholder.com/300x140?text=No+Image";

  return (
    <Grid 
      container 
      spacing={{ xs: 1.5, sm: 2.5, md: 4 }} 
      px={{ xs: 1.5, sm: 3, md: 8 }}
    >
      {products.map((product) => (
        <Grid item xs={6} sm={6} md={4} lg={3} key={product.id}>
          <Card
            sx={{
              borderRadius: { xs: 4, md: 6 },
              boxShadow: "0 4px 24px 0 rgba(255,61,61,0.08)",
              border: "1.5px solid #f5f5f5",
              bgcolor: "#fff",
              transition: "transform 0.18s, box-shadow 0.18s",
              "&:hover": {
                transform: { xs: "scale(1.02)", md: "translateY(-8px) scale(1.03)" },
                boxShadow: "0 8px 32px 0 rgba(255,61,61,0.13)",
              },
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              py: { xs: 1, sm: 1.5, md: 2 },
              px: { xs: 0.75, sm: 1, md: 1.5 },
            }}
          >
            <CardMedia
              component="img"
              image={
                product.image
                  ? `${IMAGE_BASE_URL}${product.image}`
                  : placeholderImage
              }
              alt={product.name}
              sx={{
                width: { xs: "90%", sm: 140, md: 170 },
                height: { xs: "auto", sm: 140, md: 170 },
                aspectRatio: "1",
                objectFit: "cover",
                borderRadius: "50%",
                mx: "auto",
                mb: { xs: 1, sm: 1.5, md: 2 },
                border: { xs: "2px solid #fffbe6", md: "3px solid #fffbe6" },
                boxShadow: "0 2px 12px #ffb30022",
              }}
            />
            <CardContent sx={{ textAlign: "center", p: 0, px: { xs: 0.5, sm: 1 } }}>
              <Typography
                variant="h6"
                sx={{ 
                  fontWeight: 800, 
                  color: "#222", 
                  fontSize: { xs: 14, sm: 16, md: 20 }, 
                  mb: { xs: 0.5, md: 1 },
                  lineHeight: 1.3,
                }}
              >
                {product.name}
              </Typography>
              <Box sx={{ 
                color: "#ffb300", 
                mb: { xs: 0.5, md: 1 },
                fontSize: { xs: 12, sm: 14, md: 16 },
              }}>
                {"★★★★★"}
              </Box>
              <Typography
                color="text.secondary"
                sx={{ 
                  mb: { xs: 1, sm: 1.5, md: 2 }, 
                  fontSize: { xs: 11, sm: 13, md: 15 }, 
                  minHeight: { xs: 30, sm: 35, md: 40 },
                  display: "-webkit-box",
                  WebkitLineClamp: 2,
                  WebkitBoxOrient: "vertical",
                  overflow: "hidden",
                  textOverflow: "ellipsis",
                }}
              >
                {product.description}
              </Typography>
              <Typography
                variant="h6"
                sx={{ 
                  color: "#ff3d3d", 
                  fontWeight: 900, 
                  fontSize: { xs: 16, sm: 18, md: 20 } 
                }}
              >
                ${product.price}
              </Typography>
            </CardContent>
            <CardActions
              sx={{ width: "100%", justifyContent: "center", mt: { xs: 1, md: 2 } }}
            >
              <Button
                variant="contained"
                sx={{
                  bgcolor: "#ffb300",
                  color: "#fff",
                  fontWeight: 800,
                  borderRadius: { xs: 6, md: 8 },
                  px: { xs: 1.5, sm: 2, md: 3 },
                  py: { xs: 0.5, sm: 0.75, md: 1 },
                  fontSize: { xs: 12, sm: 14, md: 16 },
                  boxShadow: "0 2px 8px #ffb30033",
                  "&:hover": { bgcolor: "#ff3d3d" },
                }}
                onClick={() => onAddToCart(product)}
                startIcon={
                  <ShoppingCartIcon
                    sx={{ 
                      color: "#fff", 
                      fontSize: { xs: 16, sm: 18, md: 22 }, 
                      mr: 0.5 
                    }}
                  />
                }
              >
                {isMobile ? "اطلب" : "ORDER NOW"}
              </Button>
            </CardActions>
          </Card>
        </Grid>
      ))}
    </Grid>
  );
};

export default ProductGrid;
